<template>
	<JBox class="s-w-full s-bg-gray-100 s-min-h-screen">
		<!-- Max width wrapper -->
		<JBox class="s-p-4 s-max-w-6xl s-m-auto s-mt-4">
			<!-- Headline -->
			<JBox class="s-w-full s-flex s-items-center s-mb-4 ">
				<JBox class="s-w-1/2">
					<JHeadline class="s-text-2xl">Releases</JHeadline>
				</JBox>
				<JFlex class="s-w-1/2 s-flex s-justify-end s-items-center">
					<JButton @click="showCreateModal = true">
						Create Release
					</JButton>
				</JFlex>
			</JBox>

			<!-- Releases -->
			<CTable :header="tableHeader" :list="list">
				<template v-slot="{ item }">
					<CTableRow>
						<CTableCell
							class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900"
						>
							{{ item.name }}
						</CTableCell>
						<CTableCell
							class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900"
						>
							{{ item.description }}
						</CTableCell>
						<CTableCell
							class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900"
						>
							{{ item.date }}
						</CTableCell>
						<CTableCell
							class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900 s-text-right"
						>
							<JButton variant="default-light-xs" @click="showUpdateModal = true">See Details</JButton>
						</CTableCell>
					</CTableRow>
				</template>
			</CTable>

			<JBox class="s-h-12 s-w-full s-px-4 s-my-4 s-flex s-justify-center s-items-center">
				<!-- Loading -->
				<JBox v-if="isLoading">
					<JSpinner variant="indigo" type="dots" :delay="0" />
				</JBox>
			</JBox>

			<!-- Create Modal -->
			<Portal to="layer0">
				<CModal :isVisible="showCreateModal">
					<JBox class="s-p-8">
						<ReleaseProductForm @cancel="showCreateModal = false" @input="showCreateModal = false">
							<template v-slot="{ handleCancel, handleSave }">
								<JFlex class="s-justify-between s-mt-6">
									<JButton variant="default-light" @click="handleSave">Release Product</JButton>
									<JButton variant="white" class="s-ml-4" @click="handleCancel">Cancel</JButton>
								</JFlex>
							</template>
						</ReleaseProductForm>
					</JBox>
				</CModal>
			</Portal>

			<!-- Update Modal -->
			<Portal to="layer1">
				<CModal :isVisible="showUpdateModal">
					<JBox class="s-p-8">
						<ReleaseProductForm @cancel="showUpdateModal = false" @input="showUpdateModal = false">
							<template v-slot="{ handleCancel, handleSave }">
								<JFlex class="s-justify-between s-mt-6">
									<JButton variant="default-light" @click="handleSave">Update</JButton>
									<JButton variant="white" class="s-ml-4" @click="handleCancel">Cancel</JButton>
								</JFlex>
							</template>
						</ReleaseProductForm>
					</JBox>
				</CModal>
			</Portal>
		</JBox>
	</JBox>
</template>

<script>
import ReleaseProductForm from "../components/ReleaseProductForm"

export default {
	components: { ReleaseProductForm },

	data() {
		return {
			textSearch: null,
			isLoading: false,

			showCreateModal: false,
			showUpdateModal: false,

			tableHeader: [{ label: "Name" }, { label: "Description" }, { label: "Date" }, { label: "" }],

			// HACK: just populating
			list: Array.from(new Array(30)).map((item, i) => ({
				id: i,
				name: `Release ${100 - i}`,
				description: `Description of the release`,
				date: `${i < 9 ? "0" : ""}${i + 1}/02/2020`,
				item
			}))
		}
	}
}
</script>
